import React from "react";
import {
  Link,
  // withRouter,
  // useHistory
} from "react-router-dom";

const header = () => {
  // let history = useHistory();
  return (
    <header id="header" className="site-header header-style-5">
      <div className="topbar topbar-style-2">
        <div className="container">
          <div className="row">
            <div className="col col-sm-7">
              <div className="topbar-contact-info-wrapper">
                <div className="topbar-contact-info">
                  <div>
                    <i
                      className="fa fa-map-marker"
                      style={{ color: "#FFF" }}
                    ></i>
                    <div className="details">
                      <p style={{ color: "#FFF" }}>
                        یزد، خیابان شهید مطهری، مرکز فناوری اقبال، سالن موسسات،
                        واحد C5
                      </p>
                    </div>
                  </div>
                  <div>
                    <i className="fa fa-phone" style={{ color: "#FFF" }}></i>
                    <div className="details">
                      <p style={{ color: "#FFF" }}>98-35-37263321+</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col col-sm-5">
              <div className="social">
                <span style={{ color: "#FFF" }}>دنبال کنید: </span>
                <ul className="social-links">
                  <li>
                    <a
                      href="https://www.facebook.com/Apafanco/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fa fa-facebook"></i>
                    </a>
                  </li>
                  {/* <li><Link to="#"><i className="fa fa-twitter"></i></Link></li> */}
                  <li>
                    <Link to="#">
                      <i className="fa fa-linkedin"></i>
                    </Link>
                  </li>
                  <li>
                    <a
                      href="https://www.aparat.com/Apafan"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="icon-aparat-ichallenge-logoap"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/apafan.co/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fa fa-instagram"></i>
                    </a>
                  </li>
                  {/* <li><Link to="#"><i className="fa fa-pinterest"></i></Link></li> */}
                  {/* <li><Link to="#"><i className="fa fa-rss"></i></Link></li> */}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="lower-topbar">
        <div className="container">
          <div className="row">
            <div className="col col-sm-3">
              <div className="site-logo">
                <Link to="/">
                  <img
                    src={process.env.PUBLIC_URL + "/assets/images/logo-2.png"}
                    alt=""
                    role="presentation"
                  />
                </Link>
              </div>
            </div>
            <div className="col col-sm-9">
              <div className="awards">
                <div>
                  <div className="icon">
                    <i className="fi flaticon-title"></i>
                  </div>
                  <div className="award-info">
                    <h4>گواهی بین المللی</h4>
                    <p>ISO 140001</p>
                  </div>
                </div>
                {/* <div>
                                        <div className="icon"><i className="fi flaticon-medal"></i></div>
                                        <div className="award-info">
                                            <h4>برنده</h4>
                                            <p>مسابقه ساخت و ساز 2019</p>
                                        </div>
                                    </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      <nav className="navigation navbar navbar-default">
        <div className="container">
          <div className="navbar-header">
            <button type="button" className="open-btn">
              <span className="sr-only">Toggle navigation</span>
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
            </button>
          </div>
          <div
            id="navbar"
            className="navbar-collapse collapse navigation-holder"
          >
            <button className="close-navbar">
              <i className="fa fa-close"></i>
            </button>
            <ul className="nav navbar-nav">
              <li>
                <a href="/">صفحه اصلی</a>
              </li>

              {/* <li >                   <Router>
                                <Link path="/">Home</Link>
                            </Router></li> */}

              <li>
                <Link to={{ pathname: "/about", state: { from: "root" } }}>
                  درباره ما
                </Link>
              </li>
              <li>
                <Link to="/produces">محصولات</Link>
              </li>
              {/* <li><Link to="projects">پروژه ها</Link></li> */}
              <li>
                {" "}
                <Link to={{ pathname: "/news", state: { from: "root" } }}>
                  خبرهای شرکت
                </Link>{" "}
              </li>
              <li>
                <Link to={{ pathname: "/contact", state: { from: "root" } }}>
                  تماس با ما
                </Link>
              </li>
            </ul>
          </div>

          <Link
            to={{ pathname: `/consult`, state: { from: "root" } }}
            className="theme-btn-s2 request-quote"
          >
            مشاوره
          </Link>
        </div>
      </nav>
    </header>
  );
};

export default header;
